(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.disclosures = [...this.querySelectorAll('.disclosure')];

      this.disclosures.forEach((disclosure) => {
        const button = disclosure.querySelector('.disclosure__button');
        const items = [...disclosure.querySelectorAll('.disclosure__item a')];

        button.addEventListener('click', () => {
          this.toggleDisclosure(disclosure);
        });

        button.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          event.preventDefault();
          if (button.getAttribute('aria-expanded') !== 'true') {
            this.toggleDisclosure(disclosure);
          }
          const targetItem = event.key === 'ArrowDown' ? items[0] : items[items.length - 1];
          targetItem?.focus();
        });

        items.forEach((item, index) => {
          item.addEventListener('click', (event) => this.onItemClick(event, disclosure));

          item.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowDown') {
              event.preventDefault();
              (items[index + 1] || items[0]).focus();
            } else if (event.key === 'ArrowUp') {
              event.preventDefault();
              (items[index - 1] || items[items.length - 1]).focus();
            }
          });
        });
      });

      this._onDocumentClick = this.onDocumentClick.bind(this);
      document.addEventListener('click', this._onDocumentClick);

      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.disclosures.forEach((d) => this.closeDisclosure(d));
      });

      const dialog = this.closest('dialog');
      if (dialog) {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      }

      this._onWindowResize = () => {
        const openLanguageList = this.querySelector('#LanguageList:not([hidden])');
        if (openLanguageList) this.fitLanguageList(openLanguageList);
      };
      window.addEventListener('resize', this._onWindowResize);
    }

    toggleDisclosure(target) {
      const button = target.querySelector('.disclosure__button');
      const list = target.querySelector('ul');
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      this.disclosures.forEach((d) => {
        if (d !== target) this.closeDisclosure(d);
      });

      button.setAttribute('aria-expanded', (!isExpanded).toString());
      if (isExpanded) {
        list.setAttribute('hidden', '');
      } else {
        list.removeAttribute('hidden');
        this.fitLanguageList(list);
      }
    }

    fitLanguageList(list) {
      if (list.id !== 'LanguageList') return;

      if (window.innerWidth >= 600) {
        list.style.removeProperty('max-height');
        return;
      }

      const viewportMargin = 16;
      const minHeight = 100;
      const spaceBelow = window.innerHeight - list.getBoundingClientRect().top - viewportMargin;

      list.style.maxHeight = `${Math.max(spaceBelow, minHeight)}px`;
    }

    closeDisclosure(disclosure) {
      disclosure.querySelector('.disclosure__button').setAttribute('aria-expanded', 'false');
      disclosure.querySelector('ul').setAttribute('hidden', '');
    }

    onDocumentClick(event) {
      this.disclosures.forEach((disclosure) => {
        if (!disclosure.contains(event.target)) {
          this.closeDisclosure(disclosure);
        }
      });
    }

    onItemClick(event, disclosure) {
      event.preventDefault();
      const link = event.currentTarget;
      const input = disclosure.querySelector('input[type="hidden"]');
      const buttonText = disclosure.querySelector('.disclosure__button-text');

      input.value = link.dataset.value;
      if (buttonText) buttonText.textContent = link.dataset.label;

      disclosure.querySelectorAll('a').forEach((a) => a.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'true');

      this.closeDisclosure(disclosure);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocumentClick);
      window.removeEventListener('resize', this._onWindowResize);
    }
  }

  customElements.define('localization-form', LocalizationForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-form-modal')) {
    customElements.define('product-form-modal', class ProductFormModal extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.querySelector('.vbb-product-card__quick-add-dialog__close')
          ?.addEventListener('click', () => this.close());
      }

      open() {
        this.dialog?.showModal();
      }

      close() {
        this.dialog?.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-form-modal')) {
    customElements.define(
      'product-form-modal',
      class ProductFormModal extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');

          this.querySelector('.vbb-product-card__mobile-cta')?.addEventListener('click', () => this.open());

          this.querySelector('.vbb-product-card__quick-add-dialog__close')?.addEventListener('click', () =>
            this.close()
          );

          this.dialog?.addEventListener('click', (e) => {
            if (e.target === this.dialog) this.close();
          });

          this.dialog?.addEventListener('close', () => {
            document.body.classList.remove('overflow-hidden');
          });

          const cardFormId = this.dataset.cardFormId;
          if (cardFormId) {
            const cardForm = document.getElementById(cardFormId);
            if (cardForm) {
              cardForm.addEventListener('variant:changed', (e) => {
                this._syncVariant(e.detail?.variantId);
              });
            }
          }
        }

        _syncVariant(variantId) {
          if (!variantId) return;
          const modalForm = this.querySelector('vbb-product-form-reactive');
          if (!modalForm) return;

          const variantDataEl = modalForm.querySelector(`#variant-details-${modalForm.id}`);
          if (!variantDataEl) return;

          let variants;
          try {
            variants = JSON.parse(variantDataEl.textContent);
          } catch (e) {
            return;
          }

          const variant = variants.find((v) => String(v.variantId) === String(variantId));
          if (!variant?.options) return;

          const selector = this.querySelector('vbb-variant-selector-reactive');
          if (!selector) return;

          selector.querySelectorAll('ul[data-option]').forEach((optionList, i) => {
            const targetValue = variant.options[i];
            if (!targetValue) return;
            const li = optionList.querySelector(`li[data-option-value="${targetValue}"]`);
            if (li && li.dataset.active !== 'true') {
              li.querySelector('a')?.click();
            }
          });
        }

        open() {
          this.dialog?.showModal();
          document.body.classList.add('overflow-hidden');
        }
        close() {
          this.dialog?.close();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["signup-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sign-up-modal')) {
    customElements.define(
      'sign-up-modal',
      class SignUpForm extends HTMLElement {
        constructor() {
          super();
          this.activeVariantId = null;
          this.handleVariantChange = this.handleVariantChange.bind(this);
          this.handleSignupButtonClick = this.handleSignupButtonClick.bind(this);
          this.handleReadMoreClick = this.handleReadMoreClick.bind(this);
          this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
          this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        }

        get activeVariant() {
          return this.activeVariantId;
        }

        fetchRecommendations() {
          const container = this.querySelector('.product-recommendations');
          if (!container) return;

          const productId = container.dataset.productId;
          if (!productId) return;

          fetch(`/recommendations/products.json?product_id=${productId}&limit=12&intent=related`)
            .then((response) => response.json())
            .then(({ products }) => {
              if (!products?.length) return;

              const filtered = products.filter((product) => !product.tags.includes('non-sellable')).slice(0, 3);

              return Promise.all(
                filtered.map((product) =>
                  fetch(`/products/${product.handle}`)
                    .then((response) => response.text())
                    .then((text) => {
                      const doc = new DOMParser().parseFromString(text, 'text/html');
                      const starsEl = doc.querySelector('.product-details-stars');
                      return { product, stars: starsEl ? starsEl.outerHTML : null };
                    })
                    .catch(() => ({ product, stars: null }))
                )
              );
            })
            .then((results) => {
              if (!results?.length) return;

              container.innerHTML = `
        <h3 class="signup-form__title">You may also like...</h3>
        <ul class="signup-modal__recommendations-list">
          ${results
            .map(({ product, stars }) => {
              const variant = product.variants[0];
              const image = product.featured_image;
              const price = (variant.price / 100).toFixed(2);
              const comparePrice = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;
              const isOnSale = comparePrice && variant.compare_at_price > variant.price;
              const colorOption = product.options?.find(
                (o) => o.name.toLowerCase() === 'color' || o.name.toLowerCase() === 'colour'
              );
              const optionCount = colorOption?.values.length || 0;
              const optionName = colorOption?.name || 'Colors';

              return `
                <li class="product">
                  <div class="card-wrapper product-card-wrapper">
                    <a href="/products/${product.handle}" class="card-link" aria-label="Link to ${product.title}">
                      <div class="card card--card card--media card--horizontal color-background-2" style="--ratio-percent: 100%;">
                        <div class="card__inner ratio" style="--ratio-percent: 100%;">
                          <div class="card__media">
                            <div class="media media--transparent">
                              ${
                                image
                                  ? `<img
                                      src="${image}"
                                      alt="${product.title}"
                                      width="125"
                                      height="125"
                                      loading="lazy"
                                    />`
                                  : `<div class="card__image-placeholder"></div>`
                              }
                            </div>
                          </div>
                        </div>
                        <div class="card__content">
                          <div class="card__information">
                            <div class="card__heading product-title">
                              <h4>${product.title}</h4>
                              ${stars ? `<div class="card__stars">${stars}</div>` : ''}
                            </div>
                            <div class="card-information">
                              <div class="price ${isOnSale ? 'price--on-sale' : ''}">
                                <div class="price__container">
                                  <div class="price__regular">
                                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                    <span class="price-item price-item--regular">
                                      £${isOnSale ? comparePrice : price}
                                    </span>
                                  </div>
                                  ${
                                    isOnSale
                                      ? `
                                      <div class="price__sale">
                                        <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                        <span class="price-item price-item--sale price-item--last">£${price}</span>
                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                        <span class="price-item price-item--regular">£${comparePrice}</span>
                                      </div>
                                    `
                                      : ''
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          ${
                            optionCount > 1
                              ? `
                              <div class="card--product-options OneLinkTx">
                                ${optionCount} available ${optionName}
                              </div>
                            `
                              : ''
                          }
                        </div>
                      </div>
                    </a>
                  </div>
                </li>
              `;
            })
            .join('')}
        </ul>
      `;
            })
            .catch((e) => {
              console.error(e);
            });
        }

        handleVariantChange(event) {
          const variant = this.variantDetails?.find(
            (variant) => String(variant.variantId) === String(event.detail?.variantId)
          );

          if (!variant) {
            this.activeVariantId = null;
            this.setVisible(false);
            return;
          }

          this.activeVariantId = variant.variantId;

          if (this.modalOpenerButton) {
            this.modalOpenerButton.dataset.variantId = variant.variantId;
          }

          this.updateModalTitle(variant);
          this.updateButtonText(variant);

          const inStock = variant.inStock === true;
          const showOutOfStock = variant.showOutOfStock === true;
          const showSignup = !inStock && !showOutOfStock;

          this.setVisible(showSignup);
        }

        updateModalTitle(variant) {
          if (!variant) return;

          const productTitle = variant?.trackingInfo?.item_name;
          const variantTitle = variant?.trackingInfo?.item_variant || variant?.title;

          if (this.modalTitleProduct && productTitle) {
            this.modalTitleProduct.textContent = productTitle;
          }

          if (this.modalTitleVariant) {
            this.modalTitleVariant.textContent = variantTitle || '';
          }

          if (this.modalTitleSeparator) {
            this.modalTitleSeparator.classList.toggle('hidden', !variantTitle);
          }
        }

        setVisible(visible) {
          this.style.display = visible ? '' : 'none';
          if (!this.modalOpenerButton) return;
          this.modalOpenerButton.disabled = !visible;
          this.modalOpenerButton.classList.toggle('hidden', !visible);
        }

        handleSignupButtonClick(event) {
          event?.preventDefault();
          event?.stopPropagation();

          const scopedForm = this.form || this.modalDialog?.querySelector('.signup-form form');
          const emailInput =
            this.emailInput ||
            scopedForm?.querySelector('[name="signup-email"]') ||
            this.modalDialog?.querySelector('[name="signup-email"]');
          const checkboxInput =
            this.checkboxInput ||
            scopedForm?.querySelector('[name="signup-checkbox"]') ||
            this.modalDialog?.querySelector('[name="signup-checkbox"]');

          if (scopedForm && !scopedForm.checkValidity()) {
            scopedForm.reportValidity();
            return;
          }

          const variantId = this.activeVariantId || this.modalOpenerButton?.dataset?.variantId;
          if (!variantId) return;

          const email = emailInput?.value?.trim();
          if (!email) {
            console.error('Email is required');
            return;
          }

          if (!checkboxInput?.checked) {
            console.error('Checkbox is required');
            return;
          }

          this.submitSignup(variantId, email);
        }

        handleReadMoreClick(event) {
          event?.preventDefault();
          this.legalText?.classList.toggle('active');
        }

        handleEmailInputChange() {
          this.updateButtonState();
        }

        handleCheckboxChange() {
          this.updateButtonState();
        }

        updateButtonText(variant) {
          const ctaText =
            variant?.backInStockCTA || this.modalOpenerButton?.dataset?.signupString || 'Notify me when available';

          if (this.signupButton) {
            this.signupButton.textContent = ctaText;
          }

          if (this.modalOpenerButton) {
            this.modalOpenerButton.textContent = ctaText;
          }
        }

        updateButtonState() {
          if (!this.signupButton || !this.emailInput || !this.checkboxInput) return;

          const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailInput.value?.trim());
          const isValid = emailValid && this.checkboxInput.checked;
          this.signupButton.disabled = !isValid;
        }

        closeModal() {
          this.modalDialog?.hide();
        }

        handleOpenerClick = (event) => {
          const opener = event.target.closest('.sign-up-button__modal');
          if (!opener) return;
          // modal-dialog is moved to <body> on connect, so resolve it from the opener, not from this element
          const target = document.querySelector(opener.closest('modal-opener')?.dataset.modal || '') || this.modalDialog;
          this.closeOtherModals(target);
        };

        closeOtherModals(target) {
          const closedDialogs = [];

          document.querySelectorAll('dialog[open]').forEach((dialog) => {
            // Never close a dialog that contains the signup modal itself
            if (target && dialog.contains(target)) return;
            closedDialogs.push(dialog);
            dialog.close();
          });

          document.querySelectorAll('modal-dialog[open]').forEach((modal) => {
            if (modal !== target) modal.hide(false);
          });

          // Closing the others clears the body scroll lock (their 'close' handlers run async, after the
          // signup modal has set it), so re-apply it once they've finished.
          if (closedDialogs.length) {
            const relock = () => {
              if (target?.hasAttribute('open')) document.body.classList.add('overflow-hidden');
            };
            closedDialogs.forEach((dialog) => dialog.addEventListener('close', relock, { once: true }));
            // Fallback: covers dialogs whose handlers ran before this listener was added
            setTimeout(relock, 0);
          }
        }

        submitSignup(variantId, email) {
          const payload = {
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          };

          fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=TkRNkf', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2024-06-15',
            },
            body: JSON.stringify(payload),
          })
            .then(() => this.closeModal())
            .catch((error) => console.log('error', error));
        }

        connectedCallback() {
          this.modalOpenerButton = this.querySelector('.sign-up-button__modal');
          this.modalDialog = this.querySelector('modal-dialog') || document.getElementById('in-motion-video');
          this.activeVariantId = this.modalOpenerButton?.dataset?.variantId || this.activeVariantId;

          // Close any other open modal (e.g. the quick-add dialog) before the signup modal opens.
          // Capture phase so this runs before modal-opener shows the signup modal, otherwise the
          // dialog's native focus-restore on close() would steal focus back from it.
          this.addEventListener('click', this.handleOpenerClick, true);
          this.signupButton =
            this.querySelector('.sign-up-button') || this.modalDialog?.querySelector('.sign-up-button');
          this.form = this.modalDialog?.querySelector('.signup-form form') || this.querySelector('.signup-form form');
          this.emailInput =
            this.modalDialog?.querySelector('[name="signup-email"]') || this.querySelector('[name="signup-email"]');
          this.checkboxInput =
            this.modalDialog?.querySelector('[name="signup-checkbox"]') ||
            this.querySelector('[name="signup-checkbox"]');
          this.modalTitleProduct =
            this.querySelector('.signup-product-title') || this.modalDialog?.querySelector('.signup-product-title');
          this.modalTitleVariant =
            this.querySelector('.signup-variant-title') || this.modalDialog?.querySelector('.signup-variant-title');
          this.modalTitleSeparator =
            this.querySelector('.signup-title-separator') || this.modalDialog?.querySelector('.signup-title-separator');
          this.legalText =
            this.querySelector('.signup-form__legal-text') ||
            this.modalDialog?.querySelector('.signup-form__legal-text');
          this.readMoreButton =
            this.querySelector('.signup-form__read-more') || this.modalDialog?.querySelector('.signup-form__read-more');
          this.form?.addEventListener('submit', (e) => e.preventDefault());

          if (this.signupButton) {
            this.signupButton.addEventListener('click', this.handleSignupButtonClick);
          }
          this.readMoreButton?.addEventListener('click', this.handleReadMoreClick);
          this.emailInput?.addEventListener('input', this.handleEmailInputChange);
          this.checkboxInput?.addEventListener('change', this.handleCheckboxChange);

          this.updateButtonState();
          this.updateButtonText();

          this.fetchRecommendations();

          const productForm = this.closest('vbb-product-form-reactive');
          if (productForm) {
            this.variantDetails = JSON.parse(
              productForm.querySelector(`#variant-details-${productForm.id}`)?.textContent
            );
            productForm.addEventListener('variant:changed', this.handleVariantChange);
            this._productForm = productForm;

            const initialVariantId = productForm.activeVariantId || productForm.dataset.activeVariant;
            if (initialVariantId) {
              this.handleVariantChange({ detail: { variantId: initialVariantId } });
            }
          }
        }

        disconnectedCallback() {
          this.signupButton?.removeEventListener('click', this.handleSignupButtonClick);
          this.readMoreButton?.removeEventListener('click', this.handleReadMoreClick);
          this.emailInput?.removeEventListener('input', this.handleEmailInputChange);
          this.checkboxInput?.removeEventListener('change', this.handleCheckboxChange);
          this._productForm?.removeEventListener('variant:changed', this.handleVariantChange);
          this.removeEventListener('click', this.handleOpenerClick, true);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vbb-reactive-cta"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vbb-reactive-cta')) {
    customElements.define(
      'vbb-reactive-cta',
      class ReactiveCTA extends HTMLElement {
        constructor() {
          super();
          this.handleVariantChange = this.handleVariantChange.bind(this);
          this.activeVariantId = this.dataset.variantId || null;
        }

        get activeVariant() {
          return this.activeVariantId;
        }

        handleVariantChange(event) {
          const nextVariantId = event.detail?.variantId;

          const variant = this.variantDetails?.find((variant) => String(variant.variantId) === String(nextVariantId));

          const ctaButton = this.button || this.querySelector('button');

          if (!variant) {
            this.activeVariantId = null;
            delete this.dataset.variantId;

            if (ctaButton) {
              ctaButton.disabled = true;
              ctaButton.classList.add('hidden');
            }

            return;
          }

          this.activeVariantId = variant.variantId;
          this.dataset.variantId = variant.variantId;

          const inStock = Boolean(variant.inStock);

          const showOutOfStock = variant.showOutOfStock === true || variant.showOutOfStock === 'true';

          const showCTA = inStock || showOutOfStock;

          if (ctaButton) {
            ctaButton.disabled = !inStock;
            ctaButton.classList.toggle('hidden', !showCTA);
          }
        }

        connectedCallback() {
          this.button = this.querySelector('button');
          if (!this.productForm) {
            this.productForm = this.closest('vbb-product-form-reactive');
            this.productFormId = this.productForm.id;
            this.variantDetails = JSON.parse(
              this.productForm.querySelector(`#variant-details-${this.productFormId}`)?.textContent
            );
            this.productForm.addEventListener('variant:changed', this.handleVariantChange);
          }

          const modal = this.closest('product-form-modal');
          if (modal && this.button) {
            this.button.addEventListener('click', () => modal.close());
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vbb-reactive-grid-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vbb-reactive-grid-carousel')) {
    customElements.define(
      'vbb-reactive-grid-carousel',
      class ReactiveGridCarousel extends HTMLElement {
        constructor() {
          super();
          this.handleVariantChange = this.handleVariantChange.bind(this);
        }

        handleVariantChange() {
          const newCarouselContentsSelector = `[data-template="carousel"][data-variant-id="${this.productForm.activeVariantId}"]`;
          const newCarouselContents = this.productForm?.querySelector(newCarouselContentsSelector);

          if (newCarouselContents?.innerHTML != null) {
            this.innerHTML = newCarouselContents.innerHTML;
          }
          this.resetSeeMoreButton();
        }

        resetSeeMoreButton() {
          this.carousel = this.querySelector('ul');
          let seeMoreButton = this.querySelector('button');

          // window.scrollTo({
          //   top: carousel.querySelector('li').offsetTop,
          //   behavior: 'smooth',
          // });

          if (!seeMoreButton) {
            return;
          }

          seeMoreButton.dataset.active = 'false';
          seeMoreButton.textContent = 'See more';
          if (!this.carousel.classList.contains('hide-overflow')) {
            this.carousel.classList.add('hide-overflow');
          }

          seeMoreButton.addEventListener('click', () => {
            if (seeMoreButton.dataset.active === 'false') {
              this.carousel.classList.remove('hide-overflow');
              seeMoreButton.dataset.active = 'true';
              seeMoreButton.textContent = 'See less';
              window.scrollTo({
                top: this.carousel.querySelector('li:nth-of-type(5)').offsetTop,
                behavior: 'smooth',
              });
            } else {
              this.carousel.classList.add('hide-overflow');
              seeMoreButton.dataset.active = 'false';
              seeMoreButton.textContent = 'See more';
              window.scrollTo({
                top: this.carousel.querySelector('li').offsetTop,
                behavior: 'smooth',
              });
            }
          });
        }

        connectedCallback() {
          if (!this.productForm) {
            this.productForm = this.closest('vbb-product-form-reactive');
            this.productForm.addEventListener('variant:changed', this.handleVariantChange);
          }
          this.resetSeeMoreButton();
        }
        disconnectedCallback() {
          if (this.productForm) {
            this.productForm.removeEventListener('variant:changed', this.handleVariantChange);
          }
        }
      }
    );
  }
  if (!customElements.get('carousel-comparison')) {
    customElements.define(
      'carousel-comparison',
      class CarouselComparison extends HTMLElement {
        constructor() {
          super();
          this.handle = null;
          this.resizeElement = null;
        }

        connectedCallback() {
          this.initSlider();
          window.addEventListener('resize', this.updateSliders.bind(this));
        }

        initSlider() {
          this.handle = this.querySelector('.carousel-comparison__handle');
          this.resizeElement = this.querySelector('.carousel-comparison__resize');
          this.adjustSlider();
          this.initDrags();
        }

        adjustSlider() {
          const width = this.offsetWidth + 'px';
          this.resizeElement.querySelector('img').style.width = width;
        }

        updateSliders() {
          this.adjustSlider();
        }

        initDrags() {
          const dragElement = this.handle;
          const resizeElement = this.resizeElement;
          const container = this;

          dragElement.addEventListener('mousedown', startDrag);
          dragElement.addEventListener('touchstart', startDrag);

          function startDrag(e) {
            dragElement.classList.add('draggable');
            resizeElement.classList.add('resizable');

            const startX = e.pageX || e.touches[0].pageX;
            const dragWidth = dragElement.offsetWidth;
            const posX = dragElement.offsetLeft + dragWidth - startX;
            const containerOffset = container.offsetLeft;
            const containerWidth = container.offsetWidth;

            const minLeft = containerOffset + 15;
            const maxLeft = containerOffset + containerWidth - dragWidth - 15;

            function moveDrag(e) {
              const moveX = e.pageX || e.touches[0].pageX;
              let leftValue = moveX + posX - dragWidth;

              if (leftValue < minLeft) {
                leftValue = minLeft;
              } else if (leftValue > maxLeft) {
                leftValue = maxLeft;
              }

              const widthValue = ((leftValue + dragWidth / 2 - containerOffset) * 100) / containerWidth + '%';

              dragElement.style.left = widthValue;
              resizeElement.style.width = widthValue;

              dragElement.addEventListener('mouseup', stopDrag);
              dragElement.addEventListener('touchend', stopDrag);
              dragElement.addEventListener('touchcancel', stopDrag);
            }

            function stopDrag() {
              dragElement.classList.remove('draggable');
              resizeElement.classList.remove('resizable');
              container.removeEventListener('mousemove', moveDrag);
              container.removeEventListener('touchmove', moveDrag);
            }

            container.addEventListener('mousemove', moveDrag);
            container.addEventListener('touchmove', moveDrag);
            e.preventDefault();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vbb-reactive-pair-with"] && !Shopify.designMode) return;
  try {
    customElements.define(
    'vbb-reactive-pair-with',
    class ReactievePairWith extends HTMLElement {
      constructor() {
        super();
        this.pairWithData = {};
        this.template = null;
        this.contentContainer = null;
        this.currentVariantId = null;
      }

      connectedCallback() {
        this.init();
        this.setupVariantListener();
      }

      init() {
        // Get the JSON data
        const dataScript = this.querySelector('.pair-with-data');
        if (dataScript) {
          this.pairWithData = JSON.parse(dataScript.textContent).pairWithIds;
        }

        // Get template and content container
        this.template = this.querySelector('.pair-with-template');
        this.contentContainer = this.querySelector('.pair-with-content');

        // Get initial variant ID
        this.currentVariantId = this.getCurrentVariantId();

        // Render initial state
        this.updatePairWith(this.currentVariantId);
      }

      setupVariantListener() {
        // Listen for variant changes
        document.addEventListener('variant:change', (event) => {
          if (event.detail && event.detail.variant) {
            this.updatePairWith(event.detail.variant.id);
          }
        });

        // Alternative: Listen for variant radio/select changes
        document.addEventListener('change', (event) => {
          if (event.target.matches('input[name="id"], select[name="id"]')) {
            this.updatePairWith(event.target.value);
          }
        });

        // Listen for legacy variant changed event
        if (!this.productForm) {
          this.productForm = this.closest('vbb-product-form-reactive');
          if (this.productForm) {
            this.productForm.addEventListener('variant:changed', (event) => {
              if (event.detail && event.detail.variantId) {
                this.updatePairWith(event.detail.variantId.toString());
              }
            });
          }
        }
      }

      getCurrentVariantId() {
        // Try to get current variant from various sources
        const variantInput = document.querySelector('input[name="id"]:checked, select[name="id"]');
        if (variantInput) {
          return variantInput.value;
        }

        // Fallback to URL parameters
        const params = new URLSearchParams(window.location.search);
        const variantFromUrl = params.get('variant');
        if (variantFromUrl) {
          return variantFromUrl;
        }

        // Fallback to first available variant in data
        const firstVariantId = Object.keys(this.pairWithData)[0];
        return firstVariantId;
      }

      updatePairWith(variantId) {
        this.currentVariantId = variantId;

        if (!this.pairWithData[variantId]) {
          this.hidePairWith();
          return;
        }

        const pairData = this.pairWithData[variantId];

        // Check if pair product is available
        if (!pairData.available) {
          this.hidePairWith();
          return;
        }

        this.showPairWith(pairData);
      }

      showPairWith(pairData) {
        if (!this.template || !this.contentContainer) return;

        // Clone the template
        const clone = this.template.content.cloneNode(true);

        // Populate the template with data
        const link = clone.querySelector('.pair-with');
        const image = clone.querySelector('img');
        const title = clone.querySelector('.pair-with-title');
        const input = clone.querySelector('input');
        const price = clone.querySelector('.pair-with-price');
        const pairText = clone.querySelector('.pair-with-text');

        // Update link
        link.href = pairData.url;
        link.id = `pair-with-${pairData.id}`;

        // Update image
        image.src = pairData.image;
        image.alt = `${pairData.title} - Pair it with`;

        // Update title
        title.textContent = pairData.title;

        // Update input
        input.value = pairData.id;
        input.id = `pair_with_variant_id_${pairData.id}`;

        // Update price
        price.textContent = pairData.price;
        price.dataset.price = pairData.price_without_currency;

        // Update pair text
        const preText = pairText.dataset.preText;
        pairText.textContent = `${preText} ${pairData.title}`;

        // Clear previous content and append new
        this.contentContainer.innerHTML = '';
        this.contentContainer.appendChild(clone);

        // Show the component
        this.style.display = '';
      }

      hidePairWith() {
        if (this.contentContainer) {
          this.contentContainer.innerHTML = '';
        }
        // Hide the entire component
        this.style.display = 'none';
      }

      // Method to manually trigger update (for external use)
      refresh(variantId = null) {
        const targetVariantId = variantId || this.getCurrentVariantId();
        this.updatePairWith(targetVariantId);
      }
    }
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vbb-reactive-product-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vbb-reactive-product-message')) {
    customElements.define('vbb-reactive-product-message', class ReactiveProductMessage extends HTMLElement {
      constructor() {
        super();
        this._data = null;
        this._productMessage = this.querySelector('.cart-message__product__message');
        this.handleVariantChange = this.handleVariantChange.bind(this);
      }

      handleVariantChange(event) {
        const variantId = event.detail.variantId;
        const message = this._data[variantId] || '';
        this._productMessage.innerHTML = message;
        this.classList.toggle('is-hidden', !message);
      }

      connectedCallback() {
        if (!this._productForm) {
          this._productForm = this.closest('vbb-product-form-reactive');
          this._productFormId = this._productForm.id;
          this._productForm.addEventListener('variant:changed', this.handleVariantChange);
        }

        if (!this._data) {
          const jsonEl = this.querySelector('script[type="application/json"]');
          if (jsonEl && jsonEl.textContent.trim()) {
            try {
              this._data = JSON.parse(jsonEl.textContent)?.variants || {};
            } catch (e) {
              console.warn('vbb-reactive-product-message: invalid JSON', e);
            }
          }
          else {
            console.warn('vbb-reactive-product-message: missing JSON script tag');
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
